import React, { useEffect, useState } from 'react';
//import SwiperCore, { Navigation, Pagination, Autoplay, Lazy } from 'swiper';
//import { Swiper, SwiperSlide } from 'swiper/react';
//import 'swiper/css';
//import 'swiper/css/navigation';
//import 'swiper/css/pagination';
import { FaWhatsapp, FaBookmark, FaStar, FaPhone } from 'react-icons/fa';
import { getImageUrl } from '../constants/Constants';
import { businessApi } from '../services/api';
import api from '../services/api';
import './BusinessSlider.css';

//SwiperCore.use([Navigation, Pagination, Autoplay, Lazy]);

const BusinessSlider = ({ categoryFilter }) => {
  const [businesses, setBusinesses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [bookmarked, setBookmarked] = useState(() => {
    const saved = localStorage.getItem('bookmarkedBusinesses');
    return saved ? JSON.parse(saved) : [];
  });

  useEffect(() => {
    async function fetchVerifiedBusinesses() {
      setLoading(true);
      setError(null);
      try {
        // Try the dedicated verified businesses endpoint first
        try {
          const verifiedResponse = await api.get('/api/verified_businesses.json');
          const data = verifiedResponse.data || verifiedResponse;

          if (data.success && Array.isArray(data.data)) {
            setBusinesses(data.data);
          } else if (Array.isArray(data)) {
            setBusinesses(data);
          } else {
            throw new Error('Invalid response format');
          }
        } catch (endpointError) {
          // Fallback: Use the existing businessApi and filter on frontend
          console.log('Verified endpoint not available, using fallback:', endpointError);
          const allBusinesses = await businessApi.fetchAll();

          // Filter for verified businesses (check multiple possible field names)
          const verifiedBusinesses = allBusinesses.filter(business => {
            return business.verified === 1 ||
              business.verified === true ||
              business.isVerified === true ||
              business.is_verified === 1 ||
              business.status === 'verified' ||
              business.verification_status === 'verified';
          });

          // If no verified filter works, show all businesses (or limit to a reasonable number)
          const businessesToShow = verifiedBusinesses.length > 0
            ? verifiedBusinesses
            : allBusinesses.slice(0, 20); // Show first 20 if no verified filter

          setBusinesses(businessesToShow);
        }
      } catch (e) {
        console.error('Error fetching verified businesses:', e);
        setError(e.message || 'Network error. Please try again later.');
      } finally {
        setLoading(false);
      }
    }
    fetchVerifiedBusinesses();
  }, []);

  const handleBookmark = (id) => {
    let updated;
    if (bookmarked.includes(id)) {
      updated = bookmarked.filter(bid => bid !== id);
    } else {
      updated = [...bookmarked, id];
    }
    setBookmarked(updated);
    localStorage.setItem('bookmarkedBusinesses', JSON.stringify(updated));
  };

  const filtered = categoryFilter
    ? businesses.filter(b => b.category === categoryFilter)
    : businesses;

  if (loading) return <div className="business-slider-loading">Loading...</div>;
  if (error) return <div className="business-slider-error">{error}</div>;
  if (!filtered.length) return <div className="business-slider-empty">No verified businesses found.</div>;

  return (
    <div className="business-slider-container">
      <div className="business-slider-header">
        <h3>Trusted Businesses Near You — Scroll & Connect Instantly!</h3>
        {/* Category filter dropdown can be added here if needed */}
      </div>
      {/* <Swiper
        spaceBetween={24}
        slidesPerView={1}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 2 },
          1024: { slidesPerView: 3 },
          1280: { slidesPerView: 4 },
        }}
        navigation
        pagination={{ clickable: true }}
        autoplay={{ delay: 3500, disableOnInteraction: false }}
        lazy={true}
        loop={true}
        className="business-swiper"
      >
        {filtered.map(business => (
          <SwiperSlide key={business.id}>
            <div className={`business-card${business.isTopRated ? ' top-rated' : ''}`}
              data-aos="fade-up"
            >
              <div className="business-card-img-wrapper">
                <img
                  src={getImageUrl(business.profile_photo || business.photo)}
                  alt={business.name}
                  className="business-card-img swiper-lazy"
                  loading="lazy"
                />
                {business.isTopRated && (
                  <span className="business-badge top-rated-badge">Top Rated</span>
                )}
                {business.isVerified && (
                  <span className="business-badge verified-badge">Verified</span>
                )}
                {business.isFeatured && (
                  <span className="business-badge featured-badge">Featured</span>
                )}
                {bookmarked.includes(business.id) && (
                  <span className="business-badge bookmark-badge"><FaBookmark /></span>
                )}
              </div>
              <div className="business-card-content">
                <h4 className="business-card-title">{business.name}</h4>
                <div className="business-card-rating">
                  {[...Array(5)].map((_, i) => (
                    <FaStar key={i} color={i < (business.rating || 0) ? '#FFD700' : '#ddd'} />
                  ))}
                  <span className="business-card-rating-value">{business.rating?.toFixed(1) || 'N/A'}</span>
                </div>
                <p className="business-card-desc">{business.description?.slice(0, 80)}{business.description?.length > 80 ? '...' : ''}</p>
                <div className="business-card-address">
                  <span>{business.city}, {business.state}</span>
                </div>
                <div className="business-card-actions">
                  <button
                    className="business-card-btn call-btn"
                    title="Call Now"
                    onClick={() => window.open(`tel:${business.phone}`)}
                  >
                    <FaPhone />
                  </button>
                  <button
                    className="business-card-btn whatsapp-btn"
                    title="Contact via WhatsApp"
                    onClick={() => window.open(`https://wa.me/${business.phone.replace(/\D/g, '')}?text=Hi! I'm interested in ${business.name}. Can you provide more information about your services?`, '_blank')}
                  >
                    <FaWhatsapp />
                  </button>
                  <button
                    className="business-card-btn bookmark-btn"
                    title={bookmarked.includes(business.id) ? 'Remove Bookmark' : 'Bookmark'}
                    onClick={() => handleBookmark(business.id)}
                  >
                    <FaBookmark color={bookmarked.includes(business.id) ? '#0d5097' : '#bbb'} />
                  </button>
                </div>
                <div className="business-card-tags">
                  {business.isVerified && <span className="business-tag verified">Verified</span>}
                  {business.isFeatured && <span className="business-tag featured">Featured</span>}
                  {business.isNew && <span className="business-tag new">New</span>}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper> */}
    </div>
  );
};

export default BusinessSlider;
